import { localize } from "utils/localizer";

const i18n = {
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
};

export default localize(i18n);
